export enum AlertTypeEnum {
    Info = "info",
    Danger = "danger",
    Success = "success",
    Warning = "warning"
}

export interface AlertDetail {
    AlertType: AlertTypeEnum;
    AlertMessage: string;
    DisplayAlert: boolean;
    ShowIfMemberHasIpClaims: boolean | undefined;
    ShowIfMemberHasTpdClaims: boolean | undefined;
    ShowIfMemberHasTiClaims: boolean | undefined;
}

export interface CorroLink {
    Files: {
        Heading: string | undefined;
        SubHeading: string | undefined;
        Description: string | undefined;
        Contact: string | undefined;
        NoFiles: {
            Message: string | undefined;
            Description: string | undefined;
        }
    }
    Verify: {
        Mobile: {
            Heading: string | undefined;
            SubHeading: string | undefined;
            Validation: {
                Required: string | undefined;
                Length: string | undefined;
                Prefix: string | undefined;
            }
            Error: {
                Failed: string | undefined;
            }
        }
        OTP: {
            Heading: string | undefined;
            SubHeading: string | undefined;
            Resend: {
                Failed: string | undefined;
                FirstCoolDown: string | undefined;
                SubsequentCoolDown: string | undefined;
            }
            Validation: {
                Required: string | undefined;
            }
            Error: {
                Failed: string | undefined;
                Invalid: string | undefined;
            }
        }
    },
    InvalidLink: {
        Heading: string | undefined;
        SubHeading: string | undefined;
    }
}

export interface Payments {
    Heading: string | undefined;
    SubHeading: string | undefined;
    LastUpdatedAlert: string | undefined;
    Scheduled: {
        Heading: string | undefined;
        SubHeading: string | undefined;
        ToolTip: string | undefined;
        NoPayments: {
            Message: string | undefined;
            Description: string | undefined;
        }
    }
    Historical: {
        Heading: string | undefined;
        SubHeading: string | undefined;
        ToolTip: string | undefined;
        NoPayments: {
            Message: string | undefined;
            Description: string | undefined;
        }
    },
    Details: {
        PaymentDateToolTip: string | undefined;
        GrossPaymentToolTip: string | undefined;
        NetPaymentToolTip: string | undefined;
        OffsetsAndAdjustmentsLabel: string | undefined;
        OffsetsAndAdjustmentsToolTip: string | undefined;
        Card: {
            Title: string | undefined;
            SubTitle: string | undefined;
            ToolTip: string | undefined;
            Overview: {
                TotalGrossPaymentToolTip: string | undefined;
            }
        },
        ExcludedAdjustments: string[] | undefined;
        PaymentDetailsMessage: string | undefined;
        PartialPayment: {
            Value: string | undefined;
            Text: string | undefined;
        },
        NetOffsetAmount: string | undefined;
    }
}

export interface MmcDashboardPageItem {
    headerText: string;
    appTitle: string;
    appTitleDescription: string;
    buttonText: string;
    benefitType: string;
    requirementCompletedStatus: string;
    thirdPartyRequirementStatus: string;
    paymentMessage: string;
    requirementInCompleteStatus: string;
    requirementReviewStatus: string;
    uploadDocumentText: string;
    uploadDocumentDescriptor: string;
    alertDetails: AlertDetail[];
    teleclaimMessage: string;
    claimsJourneyHeader: string;
    claimsJourneyContent: string;
    claimsJourneyButtonText: string;
    corroLink: CorroLink | null;
    payments: Payments | null;
}